import script from "./CardServices.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardServices.vue?vue&type=script&lang=ts&setup=true"

import "./CardServices.vue?vue&type=style&index=0&id=f12db4a4&lang=postcss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f12db4a4"]])

export default __exports__